// extracted by mini-css-extract-plugin
export default {"fadingOut":"xLqTkIdV5yzg4a0x2vwG","fadeout":"HXT77g6rbwGcOocHaWKT","micro":"Kf42sq8fBjSrMDiLPSdm","policyTypeSelector":"qg1AXYNll6MjgHgBxTgg","icon":"zkYIwyueEVhFw6AZtN0Q"};